import { Outlet } from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';

const Layout = ({
  currentLanguage,
  changeLanguage,
  lang,
}: {
  currentLanguage: string;
  changeLanguage: Function;
  lang: Locale.Keys;
}) => {
  return (
    <div className='body_wrapper'>
      <Header
        currentLanguage={currentLanguage}
        changeLanguage={changeLanguage}
        lang={lang}
      />
      <Outlet />
      <Footer lang={lang} />
    </div>
  );
};

export default Layout;
